import * as React from 'react';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { IAccountManagmentFormOptions, ISubmitStatus } from '../../pages/account/manage-account';
import EditableFormSection from '../../../../../ui-components/library/apps/organisms/editable-section/editable-form-section';
import { FormSelect } from '@enginuity-apps-ui-components/molecules/form-elements/form-select/form-select';
import { OptionTypeBase } from 'react-select';
import { IUserProfileFormData } from '@enginuity-common/types/user';

export type IManageAccountPersonalDetailsProps = {
  onSubmit: (data: IUserProfileFormData) => Promise<ISubmitStatus>;
  data?: IUserProfileFormData;
  intialEditMode?: boolean;
  options?: IAccountManagmentFormOptions | null;
};

export default function ManageAccountPersonalDetails({ onSubmit, data, intialEditMode, options }: IManageAccountPersonalDetailsProps) {
  const { register, handleSubmit, errors, setValue } = useForm();
  const [editMode, setEditMode] = useState<boolean>(!!intialEditMode)
  const [submitError, setSubmitError] = useState<JSX.Element | undefined>();
  const [formData, setFormData] = useState<IUserProfileFormData | undefined>(data);

  const saveForm = (submitData: IUserProfileFormData) => {
    onSubmit(submitData)
      .then((submitStatus: ISubmitStatus) => {
        if (submitStatus.result) {
          setEditMode(false);
        }
        else {
          setSubmitError(submitStatus.error);
        }
      })
  }

  const resetData = (mode: boolean) => {
    setFormData(data && { ...data }); //revert to original data
    setEditMode(mode);
  }

  const [qualificationSelected, setQualificationSelected] = useState<OptionTypeBase>();
  const [ageRangeSelected, setAgeRangeSelected] = useState<OptionTypeBase>();

  const handleQualificationChange = (selectedOption?: OptionTypeBase) => {
    setValue('qualification', selectedOption ? selectedOption.value : "");
    setQualificationSelected(selectedOption);
  };
  const handleAgeRangeChange = (selectedOption?: OptionTypeBase) => {
    setValue('ageRange', selectedOption ? selectedOption.value : "");
    setAgeRangeSelected(selectedOption);
  };

  useEffect(() => {
    register({ name: 'qualification' });
    register({ name: 'ageRange' });
  }, []);

  useEffect(() => {
    setFormData(data);
  }, [data]);

  useEffect(() => {
    if (formData) {
      handleQualificationChange(!!formData.qualification ? { value: formData.qualification, label: formData.qualification } : undefined);
      handleAgeRangeChange(!!formData.ageRange ? { value: formData.ageRange, label: formData.ageRange } : undefined);
    }
  }, [formData]);

  return (
    <EditableFormSection
      sectionTitle="03. Personal details"
      onSubmit={handleSubmit(saveForm)}
      submitError={submitError}
      errors={errors}
      editMode={editMode}
      onEditModeChange={(mode: boolean) => resetData(mode)}
    >
      <div className="row md-spacer-32 spacer-16">
        <div className="col-lg-6">
          {options && options.qualification && (
            <FormSelect
              label={<>Highest qualification</>}
              id="qualification"
              value={qualificationSelected}
              options={options.qualification}
              handleChange={handleQualificationChange}
              errors={errors}
              isSearchable={false}

              showReadOnly={!editMode}
            />
          )}
        </div>
        <div className="col-lg-6 lg-no-spacer spacer-16">
          {options && options.ageRange && (
            <FormSelect
              label={<>Age range</>}
              id="ageRange"
              value={ageRangeSelected}
              options={options.ageRange}
              handleChange={handleAgeRangeChange}
              errors={errors}
              isSearchable={false}
              showReadOnly={!editMode}
            />
          )}
        </div>
      </div>
    </EditableFormSection>
  );
}
